import LineCameraPlusIcon from 'LuxKit/Icons/line/LineCameraPlusIcon'
import LineCoffeeIcon from 'LuxKit/Icons/line/LineCoffeeIcon'
import LineDrinksTrayIcon from 'LuxKit/Icons/line/LineDrinksTrayIcon'
import LineFootballBallIcon from 'LuxKit/Icons/line/LineFootballBallIcon'
import LineRestaurantIcon from 'LuxKit/Icons/line/LineRestaurantIcon'
import LineShoppingBagIcon from 'LuxKit/Icons/line/LineShoppingBagIcon'
import LineTreesIcon from 'LuxKit/Icons/line/LineTreesIcon'
import LineUniversityIcon from 'LuxKit/Icons/line/LineUniversityIcon'

export const exploreCategories = [
  {
    label: 'Top attractions',
    icon: LineCameraPlusIcon,
  },
  {
    label: 'Restaurants',
    icon: LineRestaurantIcon,
  },
  {
    label: 'Cafes',
    icon: LineCoffeeIcon,
  },
  {
    label: 'Parks',
    icon: LineTreesIcon,
  },
  {
    label: 'Shopping',
    icon: LineShoppingBagIcon,
  },
  {
    label: 'Museums',
    icon: LineUniversityIcon,
  },
  {
    label: 'Bars',
    icon: LineDrinksTrayIcon,
  },
  {
    label: 'Sports',
    icon: LineFootballBallIcon,
  },
] as const

export type ExploreCategory = (typeof exploreCategories)[number]

type ExploreCategoriesLabels = {
  [K in (typeof exploreCategories)[number]['label']]: string
}

export const exploreAnalyticsCategoryLabels: ExploreCategoriesLabels = {
  'Top attractions': 'top-attractions',
  Restaurants: 'restaurants',
  Cafes: 'cafes',
  Parks: 'parks',
  Shopping: 'shopping',
  Museums: 'museums',
  Bars: 'bars',
  Sports: 'sports',
}

export function formatExploreQuery(
  place: { lePlaceName: string },
  category: ExploreCategory,
) {
  if (category.label === 'Sports') {
    return `Sports venues in ${place.lePlaceName}`
  }

  return `${category.label} in ${place.lePlaceName}`
}
